module.exports = __webpack_public_path__ + "img/thumb_07.75476134.jpg";